import has from './has';
export default has;
//# sourceMappingURL=has-key.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/has-key.js
// module id = 479
// module chunks = 3